module.exports = __webpack_public_path__ + "static/media/retail-property-grid-5.d2d13029.jpeg";